import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=69aa5574&scoped=true"
import script from "./Assignment.vue?vue&type=script&lang=js"
export * from "./Assignment.vue?vue&type=script&lang=js"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=69aa5574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa5574",
  null
  
)

export default component.exports